import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateCurrency } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateCurrency() {
  return useMutation({
    mutationFn: async ({ item, currencyId }) => {
      const payload = buildPayload(item);
      const response = await updateCurrency({ item: payload, currencyId });
      return response;
    },
    onSuccess: () => {
      toast.success("Currency Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
